<div class="text-center" *hasPermission="permissionTypes.ModifyPlayerNumbers">
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon class="menu-button"
              data-testid="fifty-fifty-autoplay-settings-menu"
              matTooltipPosition="right"
              matTooltip="Open autoplay group settings menu">
      more_horiz
    </mat-icon>
  </button>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item
          data-testid="toggle-fifty-fifty-autoplay-button"
          (click)="onToggleAutoplay()">
    <mat-icon class="dark-grey menu-icon">
      {{ rowData?.Active ? 'cancel' : 'play_arrow' }}
    </mat-icon>
    <span class="dark-grey menu-text">
      {{ rowData?.Active ? 'Disable Autoplay Group' : 'Enable Autoplay Group' }}
    </span>
  </button>
</mat-menu>
